import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  // QuestionCircleOutlined,
} from "@ant-design/icons";
import SidebarMenu from "./SidebarMenu";
import { useLogout } from "../../hooks/useAuth";

interface SidebarProps {
  isExpanded: boolean;
  setIsExpanded: (value: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isExpanded, setIsExpanded }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false); // Controls mobile sidebar visibility
  const { mutate: logout } = useLogout();

  // Detect mobile view for conditional rendering
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener("resize", checkMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      {/* Fixed Sidebar Container */}
      <aside
        className={`fixed top-16 left-0 h-[calc(100vh-4rem)] bg-white shadow-lg transition-all duration-300 z-30 
          ${isMobileOpen ? "w-72 translate-x-0" : "-translate-x-full"}
          md:translate-x-0
          ${isExpanded ? "md:w-72" : "md:w-20"}`}
      >
        {/* Sidebar Header with Toggle Buttons */}
        <div className="p-4 flex justify-between items-center border-b">
          {/* Toggle Button (only visible on desktop) */}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-xl hidden md:block"
          >
            {isExpanded ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
          </button>

          {/* Placeholder for mobile view */}
          <div className="md:hidden"></div>

          {/* Close Button for Mobile (only visible when sidebar is open on mobile) */}
          <button
            onClick={() => setIsMobileOpen(false)}
            className="md:hidden text-xl"
          >
            ✖
          </button>
        </div>

        {/* Scrollable Sidebar Menu with custom scrollbar */}
        <div className="overflow-y-auto h-[calc(100vh-8rem)] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
          <SidebarMenu isExpanded={isExpanded} isMobile={isMobile} />

          {/* Divider before support and logout */}
          <div className="border-t my-2 mx-4"></div>

          {/* Support */}
          {/* <NavLink
            to="/support"
            className={({ isActive }) =>
              `flex items-center w-[90%] mx-auto px-4 py-3 rounded-lg ${
                isActive
                  ? "bg-primary text-white hover:bg-primaryHover"
                  : "text-gray-700 hover:bg-gray-100"
              }`
            }
          >
            <QuestionCircleOutlined className="text-lg" />
            {(isMobile || isExpanded) && (
              <span className="text-sm ml-4">Support</span>
            )}
          </NavLink> */}

          {/* Logout */}
          <div className="w-[90%] mx-auto px-4 py-3 mb-4">
            <button
              onClick={() => logout()}
              className="flex items-center text-gray-700 hover:text-primaryHover rounded-lg w-full"
            >
              <LogoutOutlined className="text-lg" />
              {(isMobile || isExpanded) && (
                <span className="text-sm ml-4">Log Out</span>
              )}
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile Overlay (Closes Sidebar on Click) */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={() => setIsMobileOpen(false)}
        ></div>
      )}

      {/* Hamburger Button for Small Screens */}
      <button
        className="fixed top-4 left-2 z-40 p-1.5 bg-white shadow-md rounded-lg md:hidden"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
      >
        {isMobileOpen ? (
          <MenuFoldOutlined className="text-xl" />
        ) : (
          <MenuUnfoldOutlined className="text-xl" />
        )}
      </button>
    </>
  );
};

export default Sidebar;
